import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import AgendarCPF from "@/pages/AgendarCPF";
import AgendarEspecialidade from "@/pages/AgendarEspecialidade";
import AgendarProfissional from "@/pages/AgendarProfissional";
import AgendarHorarios from "@/pages/AgendarHorarios";
import AgendarConfirmar from "@/pages/AgendarConfirmar";
import Sucesso from "@/pages/Sucesso";
import Erro from "@/pages/Erro";
import Remarcar from "@/pages/Remarcar";
import AgendarTipo from "@/pages/AgendarTipo";
import AgendarExame from "@/pages/AgendarExame";
import PreCadastro from "@/pages/PreCadastro";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          toastOptions={{ style: { fontFamily: "IBM Plex Sans" } }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/agendar" element={<AgendarCPF />} />
		  <Route path="/agendar/pre-cadastro" element={<PreCadastro />} />
          <Route path="/agendar/especialidade" element={<AgendarEspecialidade />} />
          <Route path="/agendar/profissional" element={<AgendarProfissional />} />
          <Route path="/agendar/horarios" element={<AgendarHorarios />} />
		  <Route path="/agendar/tipo" element={<AgendarTipo />} />
		  <Route path="/agendar/exame" element={<AgendarExame />} />
          <Route path="/agendar/confirmar" element={<AgendarConfirmar />} />
          <Route path="/remarcar/:token" element={<Remarcar />} />
          <Route path="/sucesso" element={<Sucesso />} />
          <Route path="/erro" element={<Erro />} />
          <Route path="*" element={<Erro />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
